import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import { useHistory, matchPath } from 'react-router';

let popCount = 0;
let popState = '';

const withCustomPrompt = (Component) => (props) => {
  const { whitelistUrls } = props;
  const history = useHistory();

  const [showPrompt, setShowPrompt] = useState(false);
  const [currentPath, setCurrentPath] = useState('');

  /**
   * useRef is to clean up the history handler
   */
  const unblockRef = useRef();

  const handleShowModal = useCallback(() => {
    setShowPrompt(true);
  }, []);


  /**
   * function to check if current url
   * is among the whitelist urls
   */
  const containsUrl = useCallback((pathValue) => whitelistUrls.some(
    url => matchPath(pathValue, {
      path: url,
      exact: true,
      strict: false,
    }),
  ), [whitelistUrls]);

  /**
   * if next url is among the whitelist urls
   * then pass it otherwise, store the url value
   * and block the route with custom prompt
   */
  useEffect(() => {
    unblockRef.current = history.block((location, action) => {
      if (containsUrl(location?.pathname)) {
        return true;
      } else {
        /**
         * handling popState and storing
         * location in variable to persist data
         * during rerender
         *
         */
        if (action === 'POP') {
          popCount += 1;
          popState = location.pathname;
        }
        setCurrentPath(location.pathname);
        handleShowModal();
        return false;
      }
    });
    if (popCount) {
      setCurrentPath(popState);
      handleShowModal();
    }
    return () => {
      if (unblockRef.current) {
        unblockRef.current();
      }
    };
  }, [history, whitelistUrls, containsUrl, handleShowModal]);


  /**
   * Once user confirms the custom prompt, disable
   * it and move ahead with the stored route value
   */
  const handleSubmit = useCallback(() => {
    if (unblockRef) {
      unblockRef.current();
    }
    setShowPrompt(false);
    history.push(currentPath);
  }, [currentPath, history]);

  /**
   * Once user cancels the prompt, disable it
   * and keep the route same as the origin
   * where it started from
   */
  const handleClose = useCallback((route) => {
    setShowPrompt(false);
    if (route) {
      history.replace(route);
    }
  }, [history]);

  return showPrompt ? (
    <Component
      {...props}
      onSubmit={handleSubmit}
      onClose={handleClose}
    />
  ) : null;
};

export default withCustomPrompt;
